import { FulfillmentType } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { AvailableOrderTypes } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseMealCreditsDetailsPage.utils';
import { getSingularOrPlural } from 'src/utilities/getSingularOrPlural';

export interface GetOrderSettingsSubheaderProps {
  fulfillmentTypes: FulfillmentType[] | undefined;
  availableOrderTypes: AvailableOrderTypes[];
}

export function getOrderSettingsSubheader({
  fulfillmentTypes,
  availableOrderTypes,
}: GetOrderSettingsSubheaderProps): string {
  const fulfillmentTypesStr =
    fulfillmentTypes?.includes(FulfillmentType.DELIVERY) &&
    fulfillmentTypes.includes(FulfillmentType.PICKUP)
      ? 'Delivery and pickup'
      : fulfillmentTypes?.[0] || '';
  const orderTypesCount = availableOrderTypes?.length || 0;

  const orderTypesStr =
    orderTypesCount > 0
      ? `${availableOrderTypes?.join(', ')} ${getSingularOrPlural(
          orderTypesCount,
          'order'
        )}`
      : 'Select order types';

  return [fulfillmentTypesStr, orderTypesStr].filter(Boolean).join(', ');
}
